<div class="container-fluid mt-3">
  <!-- Toolbar -->
  <div class="toolbar print-controls">
    <div class="toolbar-filters">
      <!-- Location Tags Filter -->
      <div class="toolbar-filter-item" *ngIf="locationTagOptions.length > 0">
        <ng-select
          [items]="locationTagOptions"
          [multiple]="true"
          [clearable]="true"
          bindLabel="name"
          bindValue="id"
          placeholder="Filter by Location Tags..."
          [(ngModel)]="selectedLocationTags"
          (ngModelChange)="onLocationTagFilterChange()"
          class="filter-select">
        </ng-select>
      </div>
      <!-- Company Filter -->
      <div class="toolbar-filter-item" *ngIf="companyOptions.length > 0">
        <ng-select
          [items]="companyOptions"
          [multiple]="true"
          [clearable]="true"
          bindLabel="name"
          bindValue="value"
          placeholder="Filter by Company..."
          [(ngModel)]="selectedCompanies"
          (ngModelChange)="onCompanyFilterChange()"
          class="filter-select">
        </ng-select>
      </div>
      <!-- Supplier Filter -->
      <div class="toolbar-filter-item" *ngIf="supplierOptions.length > 0">
        <ng-select
          [items]="supplierOptions"
          [multiple]="true"
          [clearable]="true"
          bindLabel="name"
          bindValue="id"
          placeholder="Filter by Suppliers..."
          [(ngModel)]="selectedSuppliers"
          (ngModelChange)="onSupplierFilterChange()"
          class="filter-select">
        </ng-select>
      </div>
      <!-- Search Location -->
      <div class="toolbar-filter-item toolbar-search">
        <div class="input-group">
          <span class="input-group-text">
            <i class="fas fa-search text-muted"></i>
          </span>
          <input
            type="text"
            class="form-control"
            placeholder="Search IATA..."
            (input)="onSearch($event)">
        </div>
      </div>
    </div>
    <div class="toolbar-actions">
      <button class="btn btn-dark" (click)="downloadAsPDF()" [disabled]="loading">
        <span *ngIf="loading">
          <span class="spinner-border spinner-border-sm me-1" role="status"></span>
          Generating...
        </span>
        <span *ngIf="!loading">
          <i class="fas fa-file-pdf me-1"></i>
          Download PDF
        </span>
      </button>
    </div>
  </div>

  <!-- Report Header: tender name is shown by the parent tender layout. -->
  <div class="report-header">
    <div class="report-header-meta">
      <span class="report-header-currency">{{baseCurrency.code}} / {{baseUnit.code}}</span>
      <span class="report-header-date">Created {{ currentDateTime | date:'MMM dd, yyyy' }} at {{ currentDateTime | date:'HH:mm' }}</span>
    </div>
  </div>

  <div class="table-container print-table" id="printSection">
    <!-- Column group headers -->
    <div class="column-headers">
      <div class="column-header column-header-locations">Locations</div>
      <div class="column-header column-header-current">Current Contracts</div>
      <div class="column-header column-header-bids">Bids</div>
    </div>
    <!-- Location rows -->
    <div *ngFor="let contract of contracts" class="location-row">
      <div class="location-row-grid">
        <!-- Locations panel -->
        <div class="panel panel-locations">
          <table class="panel-table">
            <colgroup>
              <col style="width: 50%">
              <col style="width: 50%">
            </colgroup>
            <thead>
              <tr>
                <th class="subheader">Location<br>&nbsp;</th>
                <th class="subheader">Company<br>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>{{contract.location.iata}}</strong>
                  <span *ngIf="showFuelType && contract.fuelType?.code"> ({{contract.fuelType.code}})</span>
                </td>
                <td>
                  <strong>{{contract.companyChild?.getDisplayName() || contract.companyInfo}}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">{{contract.volume | number : '1.0-0'}} <span
                    class="text-muted small">{{contract.units.code}} annually</span></td>
              </tr>
              <tr *ngIf="contract.monthService">
                <td colspan="2">
                  {{contract.volume / contract.monthService | number : '1.0-0' }} <span
                    class="text-muted small">{{contract.units.code}} monthly</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Current Contracts panel -->
        <div class="panel panel-current">
          <table class="panel-table">
            <colgroup>
              <col style="width: 15%">
              <col *ngFor="let i of feeIndices" [style.width]="feeColumnWidth">
              <col style="width: 10%">
            </colgroup>
            <thead>
              <tr>
                <th class="subheader"><span class="subheader-line">Supplier</span><br>&nbsp;</th>
                <th class="subheader" *ngFor="let i of feeIndices"><span class="subheader-line">Fee{{i + 1}}</span><br>&nbsp;</th>
                <th class="subheader"><span class="subheader-line">Total</span><br>&nbsp;</th>
              </tr>
            </thead>
            <tbody *ngFor="let offer of contract.currentOffers" class="offer-group">
              <tr>
                <td class="fw-bold" rowspan="2">{{offer.supplier.name}}</td>
                <td class="align-top fee-cell" *ngFor="let i of feeIndices">
                  <div *ngIf="offer.bid['exchanged_fees_display'] && offer.bid['exchanged_fees_display'].length > i">
                    <div class="fee-value">{{offer.bid['exchanged_fees_display'][i]?.value}}</div>
                    <div class="fee-name" [ngbTooltip]="$safeNavigationMigration(offer.bid['exchanged_fees_display'][i]?.name)" placement="top">{{offer.bid['exchanged_fees_display'][i]?.name}}</div>
                  </div>
                </td>
                <td class="align-top">
                  <div>{{offer.bid['volume_fees_total'] | number: '1.4-4'}}</div>
                </td>
              </tr>
              <tr>
                <td [attr.colspan]="feeIndices.length + 1">
                  {{tender.company.settings.getFilteredOptionLabel('delivery_point', $safeNavigationMigration(offer.bid?.fuelPreference), 'name')}}
                  <span *ngIf="offer.bid?.intoPlane"> / {{offer.bid?.intoPlane}}</span>
                  <span *ngIf="offer.bid?.intoPlaneServiceProvider"> / {{offer.bid?.intoPlaneServiceProvider?.name}}</span>
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="!contract.currentOffers?.length">
              <tr>
                <td [attr.colspan]="maxFeeCount + 2" class="text-center py-3">
                  <i class="fas fa-exclamation-circle text-dark me-2"></i>
                  <span class="text-muted">No current contract selected for this location.
                    <a href="javascript:void(0);" (click)="redirectSelectContract($event)">Select
                      current contract</a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Bids panel -->
        <div class="panel panel-bids">
          <table class="panel-table">
            <colgroup>
              <col style="width: 3%">
              <col style="width: 15%">
              <col *ngFor="let i of feeIndices" [style.width]="feeColumnWidth">
              <col style="width: 10%">
            </colgroup>
            <thead>
              <tr>
                <th class="subheader subheader-icon">
                  <span class="text-muted" ngbTooltip="Bid Awards" placement="top">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-badge-icon lucide-badge">
                      <path
                        d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
                    </svg>
                  </span>
                </th>
                <th class="subheader"><span class="subheader-line">Supplier</span><br>&nbsp;</th>
                <th class="subheader" *ngFor="let i of feeIndices"><span class="subheader-line">Fee{{i + 1}}</span><br>&nbsp;</th>
                <th class="subheader"><span class="subheader-line">Total</span><br>&nbsp;</th>
              </tr>
            </thead>
            <tbody *ngFor="let offer of contract.offers" class="offer-group">
              <tr>
                <td rowspan="3" class="text-center align-top award-cell">
                  <span *ngIf="offer.status == OFFER_STATUSES.AWARDED" ngbTooltip="Awarded" placement="top" class="text-success">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                      class="lucide lucide-badge-check-icon lucide-badge-check">
                      <path
                        d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" />
                      <path d="m9 12 2 2 4-4" />
                    </svg>
                  </span>
                </td>
                <td class="fw-bold">{{offer.supplier.name}}</td>
                <td class="align-top fee-cell" *ngFor="let i of feeIndices">
                  <div *ngIf="offer.bid['exchanged_fees_display'] && offer.bid['exchanged_fees_display'].length > i">
                    <div class="fee-value">{{offer.bid['exchanged_fees_display'][i]?.value}}</div>
                    <div class="fee-name" [ngbTooltip]="$safeNavigationMigration(offer.bid['exchanged_fees_display'][i]?.name)" placement="top">{{offer.bid['exchanged_fees_display'][i]?.name}}</div>
                  </div>
                </td>
                <td class="align-top">
                  <div>{{offer.bid['volume_fees_total'] | number: '1.4-4'}}</div>
                </td>
              </tr>
              <tr>
                <td [attr.colspan]="feeIndices.length + 1">
                  {{tender.company.settings.getFilteredOptionLabel('delivery_point', $safeNavigationMigration(offer.bid?.fuelPreference), 'name')}}
                  <span *ngIf="offer.bid?.intoPlane"> / {{offer.bid?.intoPlane}}</span>
                  <span *ngIf="offer.bid?.intoPlaneServiceProvider"> / {{offer.bid?.intoPlaneServiceProvider?.name}}</span>
                </td>
              </tr>
              <tr *ngIf="offer.bid?.note">
                <td [attr.colspan]="feeIndices.length + 1">
                  <div *ngIf="!shouldTruncateNote(offer.bid.note)" class="bid-note">
                    {{offer.bid.note}}
                  </div>
                  <div *ngIf="shouldTruncateNote(offer.bid.note)">
                    <div [ngbCollapse]="!isNoteCollapsed(getNoteId(offer, 'bids'))" class="bid-note">
                      {{offer.bid.note}}
                    </div>
                    <div [ngbCollapse]="isNoteCollapsed(getNoteId(offer, 'bids'))" class="bid-note">
                      {{getTruncatedNote(offer.bid.note)}}
                    </div>
                    <button
                      type="button"
                      class="btn btn-link btn-sm p-0 mt-1 text-decoration-none"
                      (click)="toggleNoteCollapse(getNoteId(offer, 'bids'))"
                      [attr.aria-expanded]="isNoteCollapsed(getNoteId(offer, 'bids'))">
                      <i class="fas"
                         [class.fa-chevron-down]="!isNoteCollapsed(getNoteId(offer, 'bids'))"
                         [class.fa-chevron-up]="isNoteCollapsed(getNoteId(offer, 'bids'))"></i>
                      {{isNoteCollapsed(getNoteId(offer, 'bids')) ? 'Show more' : 'Show less'}}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody *ngFor="let offer of contract.mockOffers" class="offer-group">
              <tr>
                <td rowspan="3" class="text-center align-top award-cell">
                </td>
                <td class="fw-bold">
                  {{offer.name}}
                  <span class="text-muted small"> (Mock)</span>
                </td>
                <td class="align-top fee-cell" *ngFor="let i of feeIndices">
                  <div *ngIf="offer.bid['exchanged_fees_display'] && offer.bid['exchanged_fees_display'].length > i">
                    <div class="fee-value">{{offer.bid['exchanged_fees_display'][i]?.value}}</div>
                    <div class="fee-name" [ngbTooltip]="$safeNavigationMigration(offer.bid['exchanged_fees_display'][i]?.name)" placement="top">{{offer.bid['exchanged_fees_display'][i]?.name}}</div>
                  </div>
                </td>
                <td class="align-top">
                  <div>{{offer.bid['volume_fees_total'] | number: '1.4-4'}}</div>
                </td>
              </tr>
              <tr>
                <td [attr.colspan]="feeIndices.length + 1">
                  {{tender.company.settings.getFilteredOptionLabel('delivery_point', $safeNavigationMigration(offer.bid?.fuelPreference), 'name')}}
                  <span *ngIf="offer.bid?.intoPlane"> / {{offer.bid?.intoPlane}}</span>
                  <span *ngIf="offer.bid?.intoPlaneServiceProvider"> / {{offer.bid?.intoPlaneServiceProvider?.name}}</span>
                </td>
              </tr>
              <tr *ngIf="offer.bid?.note">
                <td [attr.colspan]="feeIndices.length + 1">
                  <div *ngIf="!shouldTruncateNote(offer.bid.note)" class="bid-note">
                    {{offer.bid.note}}
                  </div>
                  <div *ngIf="shouldTruncateNote(offer.bid.note)">
                    <div [ngbCollapse]="!isNoteCollapsed(getNoteId(offer, 'mock'))" class="bid-note">
                      {{offer.bid.note}}
                    </div>
                    <div [ngbCollapse]="isNoteCollapsed(getNoteId(offer, 'mock'))" class="bid-note">
                      {{getTruncatedNote(offer.bid.note)}}
                    </div>
                    <button
                      type="button"
                      class="btn btn-link btn-sm p-0 mt-1 text-decoration-none"
                      (click)="toggleNoteCollapse(getNoteId(offer, 'mock'))"
                      [attr.aria-expanded]="isNoteCollapsed(getNoteId(offer, 'mock'))">
                      <i class="fas"
                         [class.fa-chevron-down]="!isNoteCollapsed(getNoteId(offer, 'mock'))"
                         [class.fa-chevron-up]="isNoteCollapsed(getNoteId(offer, 'mock'))"></i>
                      {{isNoteCollapsed(getNoteId(offer, 'mock')) ? 'Show more' : 'Show less'}}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody *ngIf="!contract.offers?.length && !contract.mockOffers?.length">
              <tr>
                <td [attr.colspan]="maxFeeCount + 3" class="text-center py-3">
                  <i class="fas fa-info-circle text-dark me-2"></i>
                  <span class="text-muted">No bids available</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!contracts || !contracts.length">
      <div class="d-flex justify-content-center p-5">
        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </ng-container>
    <div class="row mb-3 mt-4" *ngIf="hasMore && contracts && contracts.length > 0">
      <div class="col-12 text-center">
        <button class="btn btn-outline-dark px-5" (click)="loadMore()" [disabled]="loadingMore">
          <span *ngIf="loadingMore" class="spinner-border spinner-border-sm me-2" role="status"></span>
          {{ loadingMore ? 'Loading...' : 'Load More' }}
        </button>
        <p class="text-muted small mt-2">Showing {{contracts.length}} of {{totalPageItems}} locations</p>
      </div>
    </div>
  </div>
</div>
